import { isEmpty } from './baseHelpers';

export const isStaffUser = (user) => {
  return user === 'staff' || user?.userInfo?.userType === 'staff';
};

/**
 * Whether this user can edit everything, e.g. delete sessions
 * We currently restrict restaurants from doing this, but account managers can,
 * and it should be allowed in the demo env
 */
export const canEditAll = (user) => {
  return isStaffUser(user) || import.meta.env.VITE_MODE === 'demo';
};

// const scopes = ['groupAdmin', 'manager', 'staff', 'finance'];
export const SCOPES = {
  GROUP_ADMIN: 'groupAdmin',
  MANAGER: 'manager', // manager and groupAdmin are the same
  STAFF: 'staff',
  FINANCE: 'finance',
};

const SCOPED_FEATURES = {
  INSIGHTS: [SCOPES.GROUP_ADMIN, SCOPES.MANAGER, SCOPES.STAFF, SCOPES.FINANCE],
  OFFERS: [SCOPES.GROUP_ADMIN, SCOPES.MANAGER],
  TRANSACTIONS: [SCOPES.GROUP_ADMIN, SCOPES.MANAGER, SCOPES.STAFF, SCOPES.FINANCE],
  AUDIENCE_TARGETING: [SCOPES.GROUP_ADMIN, SCOPES.MANAGER],
  SETTLEMENTS: [SCOPES.GROUP_ADMIN, SCOPES.MANAGER, SCOPES.FINANCE],
  MENUS: [SCOPES.GROUP_ADMIN, SCOPES.MANAGER, SCOPES.STAFF],
  BOOKINGS: [SCOPES.GROUP_ADMIN, SCOPES.MANAGER, SCOPES.STAFF],
  HELP_CENTRE: [SCOPES.GROUP_ADMIN, SCOPES.MANAGER, SCOPES.STAFF, SCOPES.FINANCE],
  PROFILE: [SCOPES.GROUP_ADMIN, SCOPES.MANAGER],
};

/** List of features that have their access gated */
export const FEATURE_SCOPES = {
  INSIGHTS: 'INSIGHTS',
  OFFERS: 'OFFERS',
  TRANSACTIONS: 'TRANSACTIONS',
  AUDIENCE_TARGETING: 'AUDIENCE_TARGETING',
  SETTLEMENTS: 'SETTLEMENTS',
  MENUS: 'MENUS',
  BOOKINGS: 'BOOKINGS',
  HELP_CENTRE: 'HELP_CENTRE',
  PROFILE: 'PROFILE',
};

/**
 * Whether the partner has access to the feature
 */
export const hasAccess = (user, feature) => {
  const validScopes = SCOPED_FEATURES?.[feature];

  // If no scope, anyone can access this page
  if (isEmpty(user) || isEmpty(user?.userInfo?.scope) || isEmpty(validScopes)) {
    return true;
  }

  // Staff users can do everything
  if (canEditAll(user)) {
    return true;
  }

  // Only access if correct scope
  return validScopes.includes(user?.userInfo?.scope);
};
